module.exports = __webpack_public_path__ + "static/media/feature_privacy.092aad6b.png";